import { Wrench, CheckCircle } from 'lucide-react';
import apiClient from '../../../../services/apiClient';

const Troubleshooting = () => {
    return (
        <div className="p-6 max-w-4xl mx-auto">
            <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                <Wrench className="text-orange-500" />
                Troubleshooting
            </h2>
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                <div className="flex items-center justify-center py-12 text-center">
                    <div>
                        <div className="inline-flex p-3 bg-blue-50 rounded-full mb-4">
                            <CheckCircle className="text-blue-500" size={32} />
                        </div>
                        <h3 className="font-semibold text-gray-800 mb-1">System is healthy</h3>
                        <p className="text-sm text-gray-500 max-w-sm">
                            No known issues detected. Workflow definitions are now managed centrally by the system.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Troubleshooting;
